import { buildApiUrl } from "../../../config.js";
import React, { useState } from "react";
import { FaEdit, FaTimes } from "react-icons/fa";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const EditClientModal = ({ client, onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    firmName: client.firmName || "",
    contactPerson: client.contactPerson || "",
    mobileNo: client.mobileNo || "",
    email: client.email || "",
    waGroupId: client.waGroupId || "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(
        buildApiUrl(`/api/clients/${client._id}`),
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formData),
        }
      );

      if (response.ok) {
        toast.success("Client updated successfully!");
        onSubmit();
        onClose();
      } else {
        toast.error("Failed to update client.");
      }
    } catch (error) {
      toast.error("An error occurred while updating the client.");
    }
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-70 z-50 transition-opacity duration-300">
      <div className="bg-white rounded-lg shadow-2xl w-full max-w-sm mx-4 p-4 transform transition-all duration-300 scale-100">
        <div className="flex items-center justify-between border-b border-gray-200 pb-2">
          <div className="flex items-center gap-2">
            <FaEdit className="text-indigo-600" size={16} />
            <h2 className="text-lg font-semibold text-gray-800">Edit Client</h2>
          </div>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700 transition-colors"
          >
            <FaTimes size={16} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="mt-3 space-y-3">
          <div>
            <label
              htmlFor="firmName"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Firm Name
            </label>
            <input
              id="firmName"
              name="firmName"
              type="text"
              value={formData.firmName}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="contactPerson"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Contact Person
            </label>
            <input
              id="contactPerson"
              name="contactPerson"
              type="text"
              value={formData.contactPerson}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="mobileNo"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Mobile Number
            </label>
            <input
              id="mobileNo"
              name="mobileNo"
              type="text"
              value={formData.mobileNo}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="email"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Email
            </label>
            <input
              id="email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              required
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div>
            <label
              htmlFor="waGroupId"
              className="block text-xs font-medium text-gray-600 mb-1"
            >
              Whatsapp Group ID
            </label>
            <input
              id="waGroupId"
              name="waGroupId"
              type="text"
              value={formData.waGroupId}
              onChange={handleChange}
              className="w-full px-3 py-2 text-xs border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 transition-colors"
            />
          </div>

          <div className="flex justify-end items-center pt-3 border-t border-gray-200 gap-2">
            <button
              type="button"
              onClick={onClose}
              className="px-3 py-2 bg-gray-200 text-gray-700 text-xs rounded-md hover:bg-gray-300 transition-colors duration-200"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-3 py-2 bg-indigo-600 text-white text-xs rounded-md hover:bg-indigo-800 transition-colors duration-200 flex items-center gap-1"
            >
              <FaEdit size={12} />
              Save Changes
            </button>
          </div>
        </form>
      </div>
      <ToastContainer />
    </div>
  );
};

export default React.memo(EditClientModal);
